// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var OptInRoute = function OptInRoute() {
  return {
    path: '/email/opt-in/:token',
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('features/Email/OptIn/OptInContainer').OptInContainer
        });
      }, 'optIn');
    }
  };
};